import React from 'react';
import { FileTextIcon, UserIcon, BuildingIcon, CalendarIcon, ClockIcon, MapPinIcon, DollarSignIcon, TruckIcon, TagIcon } from 'lucide-react';
export function QuotePreview({
  quoteData,
  quoteType,
  quoteNumber
}) {
  // Valores por defecto para evitar errores
  const customerInfo = quoteData.customerInfo || {};
  const shipping = quoteData.shipping || {};
  const currency = shipping.currency || quoteData.currency || '$';
  const pivots = quoteData.pivots || [];
  const parts = quoteData.parts || [];
  const items = quoteData.items || [];
  const issueDate = quoteData.issueDate || quoteData.date || 'Unknown date';
  const expiryDate = quoteData.expiryDate || 'Unknown';
  return <div className="text-gray-800" data-id="element-4918" data-mp="zurufhl1esk7">
      {/* Header */}
      <div className="flex justify-between items-start mb-8 pb-8 border-b border-gray-200" data-id="element-4919" data-mp="zwcmn0jvpzew">
        <div data-id="element-4920" data-mp="uuwz91u8bgtc">
          <div className="flex items-center mb-2" data-id="element-4921" data-mp="uxj7l3oy20cm">
            <div className="p-2 mr-3 bg-blue-600 rounded-lg" data-id="element-4922" data-mp="qtlcr56njbpd">
              <FileTextIcon size={20} className="text-white" data-id="element-4923" data-mp="2l4zduepcev7s" />
            </div>
            <h1 className="text-3xl font-bold text-gray-800" data-id="element-4924" data-mp="2l2we32ye1npv">
              Quote #{quoteNumber}
            </h1>
          </div>
          <div className="text-gray-600" data-id="element-4925" data-mp="2b7349rc208bs">
            {quoteType} Quote • Created by {quoteData.quotedBy || 'Unknown'}
          </div>
          <div className="mt-4 flex flex-wrap gap-4" data-id="element-4926" data-mp="2g6xsto8cwlto">
            <div className="flex items-center text-gray-600" data-id="element-4927" data-mp="33vh3gaevpaox">
              <CalendarIcon size={16} className="mr-1" data-id="element-4928" data-mp="33w0er8a0x0tz" />
              Issue Date: {issueDate}
            </div>
            <div className="flex items-center text-gray-600" data-id="element-4929" data-mp="38shaanjjyhh3">
              <ClockIcon size={16} className="mr-1" data-id="element-4930" data-mp="2utr3uhauf5g2" />
              Expiry Date: {expiryDate}
            </div>
          </div>
        </div>
        <div className="flex flex-col items-end" data-id="element-4931" data-mp="2yygxdzi147xt">
          <div className="text-3xl font-bold text-blue-600" data-id="element-4932" data-mp="1jfdqw7hmoaet">
            {currency}
            {(quoteData.amount || 0).toLocaleString(undefined, {
            maximumFractionDigits: 2
          })}
          </div>
          {quoteData.status && <div className="mt-2 inline-flex items-center px-3 py-1 rounded-full bg-blue-100 text-blue-800 text-sm" data-id="element-4933" data-mp="3q34c64llefps">
              <TagIcon size={14} className="mr-1" data-id="element-4934" data-mp="3l75l298vqjlo" />
              {quoteData.status.charAt(0).toUpperCase() + quoteData.status.slice(1)}
            </div>}
        </div>
      </div>

      {/* Customer Information */}
      <div className="mb-8" data-id="element-4935" data-mp="37dehrilqrvye">
        <h2 className="text-xl font-bold mb-4" data-id="element-4936" data-mp="37efx3z9sj4lx">Customer Information</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 bg-gray-50 p-4 rounded-lg" data-id="element-4937" data-mp="32el6lwtxgh1e">
          <div data-id="element-4938" data-mp="2xf8lphmm9k1g">
            <h3 className="text-sm font-medium text-gray-500 mb-2" data-id="element-4939" data-mp="2xep09qxrcdio">Bill To</h3>
            <div className="flex items-start" data-id="element-4940" data-mp="2sg5f3sqzn5rd">
              {customerInfo.clientType === 'dealer' || quoteData.clientType === 'dealer' ? <BuildingIcon size={18} className="mr-2 text-gray-400 mt-0.5" data-id="element-4941" data-mp="vodiw5tzskl8" /> : <UserIcon size={18} className="mr-2 text-gray-400 mt-0.5" data-id="element-4942" data-mp="vlhnao5ma7zy" />}
              <div data-id="element-4943" data-mp="qpk6kgqfyzmn">
                <div className="font-medium" data-id="element-4944" data-mp="qmy24pyul08n">
                  {customerInfo.billToCompany || customerInfo.dealerName || quoteData.dealerName || 'Not specified'}
                </div>
                <div className="text-gray-600" data-id="element-4945" data-mp="135a4h5a27epb">
                  {customerInfo.billToAddress || 'No address provided'}
                </div>
                <div className="text-gray-600" data-id="element-4946" data-mp="1cxpmu3p9q5aq">
                  {customerInfo.billToCountry || quoteData.country || 'Country not specified'}
                </div>
              </div>
            </div>
          </div>
          <div data-id="element-4947" data-mp="k9k0xdmhaa9b">
            <h3 className="text-sm font-medium text-gray-500 mb-2" data-id="element-4948" data-mp="k9achuh30b5q">Ship To</h3>
            <div className="flex items-start" data-id="element-4949" data-mp="p7c10uxa12ol">
              <MapPinIcon size={18} className="mr-2 text-gray-400 mt-0.5" data-id="element-4950" data-mp="p9okjcionl3r" />
              <div data-id="element-4951" data-mp="u89j77iadwq3">
                <div className="font-medium" data-id="element-4952" data-mp="u4lqgako1ecf">
                  {customerInfo.shipToCompany || customerInfo.dealerName || quoteData.dealerName || 'Same as billing'}
                </div>
                <div className="text-gray-600" data-id="element-4953" data-mp="25k0n1d8yq470">
                  {customerInfo.shipToAddress || 'No address provided'}
                </div>
                <div className="text-gray-600" data-id="element-4954" data-mp="39jyx6fozbv3g">
                  {customerInfo.shipToCountry || customerInfo.billToCountry || quoteData.country || 'Country not specified'}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Quote Items */}
      <div className="mb-8" data-id="element-4955" data-mp="1c0emvwrtgkd">
        <h2 className="text-xl font-bold mb-4" data-id="element-4956" data-mp="1b8i9ivcnet1">Quote Items</h2>
        <div className="overflow-x-auto" data-id="element-4957" data-mp="3sitcbpscuxk5">
          <table className="min-w-full divide-y divide-gray-200" data-id="element-4958" data-mp="3shs21nj5yf3h">
            <thead className="bg-gray-50" data-id="element-4959" data-mp="a53n0psk7385">
              <tr data-id="element-4960" data-mp="a42ccmfggiqy">
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-4961" data-mp="a6okan69d09p">
                  Description
                </th>
                <th scope="col" className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-4962" data-mp="k39lexf5pr89">
                  Quantity
                </th>
                <th scope="col" className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-4963" data-mp="yp6x4am1zayx">
                  Unit Price
                </th>
                <th scope="col" className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-4964" data-mp="orj35mw9u7ht">
                  Total
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200" data-id="element-4965" data-mp="fyfjgwv18yeq">
              {/* Render pivot items if available */}
              {pivots.length > 0 && pivots.map((pivot, index) => <tr key={`pivot-${index}`} data-id="element-4966" data-mp="krigxg2xks07" data-mpi={index}>
                    <td className="px-6 py-4 whitespace-nowrap" data-id="element-4967" data-mp="61ue2af3plad">
                      <div className="font-medium text-gray-900" data-id="element-4968" data-mp="azmg3x9gmnsa">
                        {pivot.name}
                      </div>
                      <div className="text-gray-500" data-id="element-4969" data-mp="3t6jyca4ghnm8">{pivot.description}</div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-right text-gray-500" data-id="element-4970" data-mp="10n5wa91qk36">
                      1
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-right text-gray-500" data-id="element-4971" data-mp="23qgda0ooxpq2">
                      {currency}
                      {pivot.price.toLocaleString(undefined, {
                  maximumFractionDigits: 2
                })}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-right text-gray-900 font-medium" data-id="element-4972" data-mp="1p121klxn6w7i">
                      {currency}
                      {pivot.price.toLocaleString(undefined, {
                  maximumFractionDigits: 2
                })}
                    </td>
                  </tr>)}
              {/* Render parts items if available */}
              {parts.length > 0 && parts.map((part, index) => <tr key={`part-${index}`} data-id="element-4973" data-mp="28mx2yzbjgc59" data-mpi={index}>
                    <td className="px-6 py-4 whitespace-nowrap" data-id="element-4974" data-mp="119mxanmb24tm">
                      <div className="font-medium text-gray-900" data-id="element-4975" data-mp="117s7auw6fmio">
                        {part.name || part.partNumber}
                      </div>
                      <div className="text-gray-500" data-id="element-4976" data-mp="38wfwpl1yscom">{part.description}</div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-right text-gray-500" data-id="element-4977" data-mp="3cwgo06a5wid3">
                      {part.quantity || 1}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-right text-gray-500" data-id="element-4978" data-mp="3hui2sf0k1vir">
                      {currency}
                      {(part.price || 0).toLocaleString(undefined, {
                  maximumFractionDigits: 2
                })}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-right text-gray-900 font-medium" data-id="element-4979" data-mp="e0alc4ayvrz">
                      {currency}
                      {((part.price || 0) * (part.quantity || 1)).toLocaleString(undefined, {
                  maximumFractionDigits: 2
                })}
                    </td>
                  </tr>)}
              {/* Render project items if available */}
              {items.length > 0 && items.map((item, index) => <tr key={`item-${index}`} data-id="element-4980" data-mp="gzskvjx1ax0n" data-mpi={index}>
                    <td className="px-6 py-4 whitespace-nowrap" data-id="element-4981" data-mp="gyhhvmbextal">
                      <div className="font-medium text-gray-900" data-id="element-4982" data-mp="cz8mye4mzpdg">
                        {item.name}
                      </div>
                      <div className="text-gray-500" data-id="element-4983" data-mp="qpc44qonssw1">{item.description}</div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-right text-gray-500" data-id="element-4984" data-mp="lraji1bl4lig">
                      {item.quantity || 1}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-right text-gray-500" data-id="element-4985" data-mp="3q5h30f61lglb">
                      {currency}
                      {(item.price || 0).toLocaleString(undefined, {
                  maximumFractionDigits: 2
                })}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-right text-gray-900 font-medium" data-id="element-4986" data-mp="1jeiz5fown0cj">
                      {currency}
                      {((item.price || 0) * (item.quantity || 1)).toLocaleString(undefined, {
                  maximumFractionDigits: 2
                })}
                    </td>
                  </tr>)}
              {/* If no items are available, show a placeholder */}
              {pivots.length === 0 && parts.length === 0 && items.length === 0 && <tr data-id="element-4987" data-mp="2ne7nl6qwt693">
                    <td colSpan={4} className="px-6 py-4 text-center text-gray-500" data-id="element-4988" data-mp="2sbg4z548h69a">
                      No items specified in this quote
                    </td>
                  </tr>}
              {/* Total row */}
              <tr className="bg-gray-50" data-id="element-4989" data-mp="3k35g0ib6ss33">
                <td colSpan={3} className="px-6 py-4 whitespace-nowrap text-right font-medium text-gray-700" data-id="element-4990" data-mp="3k245qg1zw9mf">
                  Total Amount:
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-right text-blue-600 font-bold" data-id="element-4991" data-mp="3b9si11y9n0a5">
                  {currency}
                  {(quoteData.amount || 0).toLocaleString(undefined, {
                  maximumFractionDigits: 2
                })}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      {/* Shipping & Terms */}
      <div className="mb-8" data-id="element-4992" data-mp="2nhwymt4ahejr">
        <h2 className="text-xl font-bold mb-4" data-id="element-4993" data-mp="2ngu5eejhv00o">Shipping & Terms</h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 bg-gray-50 p-4 rounded-lg" data-id="element-4994" data-mp="29innw8yurcn6">
          <div data-id="element-4995" data-mp="2djpgw826esgp">
            <h3 className="text-sm font-medium text-gray-500 mb-2" data-id="element-4996" data-mp="2djfxx4fjtlki">
              Payment Terms
            </h3>
            <div className="flex items-center" data-id="element-4997" data-mp="1zrjcfj8dy9x3">
              <DollarSignIcon size={18} className="mr-2 text-gray-400" data-id="element-4998" data-mp="1zqrgg7avma6a" />
              <div className="font-medium" data-id="element-4999" data-mp="24kvn0pg8cg6u">
                {shipping.paymentTerms || 'Not specified'}
              </div>
            </div>
          </div>
          <div data-id="element-5000" data-mp="1usya9e9kpg60">
            <h3 className="text-sm font-medium text-gray-500 mb-2" data-id="element-5001" data-mp="1uuj5z77mj55g">Incoterm</h3>
            <div className="flex items-center" data-id="element-5002" data-mp="1gt6qsy0af7km">
              <TruckIcon size={18} className="mr-2 text-gray-400" data-id="element-5003" data-mp="1gui53rrczxpz" />
              <div className="font-medium" data-id="element-5004" data-mp="1lrrr0xfjhr92">
                {shipping.incoterm || 'Not specified'}
              </div>
            </div>
          </div>
          <div data-id="element-5005" data-mp="128ujs39f6n5j">
            <h3 className="text-sm font-medium text-gray-500 mb-2" data-id="element-5006" data-mp="x86i8nnkenx2">Currency</h3>
            <div className="flex items-center" data-id="element-5007" data-mp="xa9hzzeirvez">
              <DollarSignIcon size={18} className="mr-2 text-gray-400" data-id="element-5008" data-mp="1b8r1fkxe6lr3" />
              <div className="font-medium" data-id="element-5009" data-mp="176cil0tq3lzt">{currency}</div>
            </div>
          </div>
        </div>
      </div>

      {/* Notes & Terms */}
      <div className="mb-8" data-id="element-5010" data-mp="1l4avs2wb5cdq">
        <h2 className="text-xl font-bold mb-4" data-id="element-5011" data-mp="1l3iymnn2b6lc">Notes & Terms</h2>
        <div className="bg-gray-50 p-4 rounded-lg" data-id="element-5012" data-mp="1g5zj7kemonrt">
          <p className="text-gray-600" data-id="element-5013" data-mp="1uvfbj4tt519m">
            {shipping.notes || quoteData.notes || 'This quote is valid until the expiry date mentioned above. Please contact us if you have any questions.'}
          </p>
        </div>
      </div>
    </div>;
}